import * as React from 'react';
import { CardSection, IconStethoscope } from '@maiia/design-system';
import { Box } from '@mui/material';
import { useTranslation } from '@/src/i18n';
import Tag from '../../atoms/Tag/Tag';

type Props = {
  items: Array<any>;
};

const Expertises = ({ items }: Props) => {
  const { t } = useTranslation();

  return (
    <CardSection icon={<IconStethoscope />} title={t('expertises')}>
      <Box display="flex" flexWrap="wrap" alignItems="center">
        {items.map(expertise => (
          <Tag key={expertise.id}>{expertise.name}</Tag>
        ))}
      </Box>
    </CardSection>
  );
};

export default Expertises;
